var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IncentivesDataSource_1;
import { DateConverter, JSON, JsonConverter, JsonSchema } from '@symon-ai/wisepipe-serialize';
const Schema = {
    $id: 'urn:wisepipe-common-data:IncentivesDataSource',
    type: 'object',
    properties: {
        dataSourceID: { type: 'string', pattern: '^([_\\p{L}][_\\p{L}0-9]*)$' }, // Must start with a letter or underscore, followed by only numbers, letters, and underscores
        columns: {
            type: 'array',
            items: { $ref: 'urn:wisepipe-common-data:Column' },
            uniqueItemProperties: ['name']
        },
        lastModified: { type: 'string', format: 'date-time' },
        displayName: { type: 'string' }
    },
    required: ['dataSourceID', 'columns', 'lastModified']
};
let IncentivesDataSource = IncentivesDataSource_1 = class IncentivesDataSource {
    constructor(dataSourceID, columns, lastModified, displayName) {
        this.dataSourceID = dataSourceID;
        this.columns = columns;
        this.lastModified = lastModified;
        if (displayName !== undefined) {
            this.displayName = displayName;
        }
        JSON.validate(this, IncentivesDataSource_1);
    }
};
__decorate([
    JsonConverter(new DateConverter('date-time'))
], IncentivesDataSource.prototype, "lastModified", void 0);
IncentivesDataSource = IncentivesDataSource_1 = __decorate([
    JsonSchema(Schema)
], IncentivesDataSource);
export { IncentivesDataSource };
//# sourceMappingURL=incentivesDataSource.js.map